/* eslint-disable no-unused-vars */

import { default as Goals, getGoals } from "./Goals";
import _ from "lodash";

export default class GoalsArray {
    baseArray = [];
    values = [];
    groupedGoals = [];
    length = 0;

    constructor(list) {
        if (list) {
            this.baseArray = this.copy(list);
            this.groupedGoals = this.groupGoals(this.baseArray);
            this.length = list.length;
        }
    }

    copy(array) {
        let newArray = [];
        array.forEach(e => {
            newArray.push(_.cloneDeep(e));
        });
        return newArray;
    }

    items() {
        return this.baseArray;
    }

    forEach(callback = (item, index, array) => { }) {
        for (let i = 0; i < this.baseArray.length; i++) {
            const element = this.baseArray[i];
            callback(element, i, this.baseArray);
        }
    }

    groupGoals(goals) {
        if (goals) {
            let ids = new Set();
            goals.forEach(e => {
                ids.add(e.id);
            });
            let goal = new Goals({ id: [...ids] });
            return goal;
        }
    }
    async setData(params) {
        const goalsInstances = await this.setValues(params);
        return goalsInstances;
    }
    async setValues(params = {}) {
        try {
            if (this.length === 0) {
                return [];
            }
            if (this.groupedGoals) {
                this.values = await this.groupedGoals.setValues(params);
                this.separateValues(this.values);
                return this.baseArray;
            }
            throw Error("Goals not found in instance");
        } catch (error) {
            console.error(error);
            return [];
        }
    }

    separateValues(values) {
        let map = new Map();
        for (let i = 0; i < this.baseArray.length; i++) {
            const { id } = this.baseArray[i];
            map.set(id, i);
            this.baseArray[i].values = [];
        }
        values.forEach(value => {
            let index = map.get(value.goals);
            this.baseArray[index].values.push(value);
        });
    }

    conversion(eu) {
        this.baseArray = this.baseArray.map(e => {
            e.conversion(eu);
            return e;
        });
    }
}

export async function getGoalsArray(params) {
    try {
        let goals = await getGoals(params);
        let goalsArray = new GoalsArray(goals);
        return goalsArray;
    } catch (error) {
        return Promise.reject(error);
    }
}

// Same function as implemented in historical measures
export function summation(array) {
    if (!array || !array.length) return [];
    let object = new Object();
    array.forEach(goals => {
        goals.forEach(item => {
            let { timestamp, value } = item;
            value = parseFloat(value);
      
            object[timestamp] =  object[timestamp] ? object[timestamp] + value : value;
        });
    });
    let dataset = [];
    Object.keys({...object}).forEach(key => {
        dataset.push({
            timestamp: key,
            value: Number(object[key]).toFixed(2)
        });
    });
    return dataset;
}

export function summationByKey(array, groupKey = "name") {
    let object = {};
    array.forEach(item => {
        const key = item[groupKey];
        object[key] = object[key] || [];
        object[key].push(item);
    });
    let goals = [];
    for (const key in object) {
        const goalsArray = object[key];
        const data = summation(goalsArray);
        const goal = goalsArray[0];
        goal.values = data;
        goals.push(goal);
    }
    return goals;
}